// 状态卡（EP-004-S3）—— home / awaitingReveal 渲染；away 由模糊档位文案承担（不渲染）。
// awaitingReveal 态整张可点击，触发揭晓（markRevealReady）。
//
// 🆕 v2（P-POSTCARD-RECONCEIVE / B11）：右上朱橘 #C0503A 圆点 + 数字（未读明信片数）。
//   仅 home / awaitingReveal 渲染；away 模糊档位不渲染（StatusCard 不挂载）。
//   点击圆点 → 跳到空间明信片 tab（onPostcardBadgeClick 回调）。
import type { KeyboardEvent as ReactKeyboardEvent } from 'react';

// onClick / ariaLabel / onPostcardBadgeClick 显式允许 undefined（| undefined），
// 以兼容 exactOptionalPropertyTypes 下 MainView 的 `cond ? value : undefined` 条件传参写法。
interface StatusCardProps {
  text: string;
  clickable: boolean;
  onClick?: (() => void) | undefined;
  ariaLabel?: string | undefined;
  // 🆕 v2：未读明信片角标；0 或不传 → 不渲染
  unreadPostcardCount?: number | undefined;
  // 🆕 v2：点击角标回调（跳到空间明信片 tab）
  onPostcardBadgeClick?: (() => void) | undefined;
}

export function StatusCard({
  text,
  clickable,
  onClick,
  ariaLabel,
  unreadPostcardCount,
  onPostcardBadgeClick,
}: StatusCardProps) {
  const className = clickable ? 'status-card status-card--clickable' : 'status-card';
  const handleClick = clickable ? onClick : undefined;
  const handleKey = clickable
    ? (e: ReactKeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      }
    : undefined;

  const showBadge = (unreadPostcardCount ?? 0) > 0;

  return (
    <div
      className={className}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onClick={handleClick}
      onKeyDown={handleKey}
      aria-label={ariaLabel}
    >
      <span className="status-card__text">{text}</span>
      {showBadge && (
        <button
          type="button"
          className="status-card__postcard-badge"
          aria-label={`未读明信片 ${unreadPostcardCount} 封，点击查看`}
          onClick={(e) => {
            // 阻止冒泡到外层 clickable（避免同时触发 beginReveal）
            e.stopPropagation();
            onPostcardBadgeClick?.();
          }}
        >
          {unreadPostcardCount}
        </button>
      )}
    </div>
  );
}
